module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAEZSURBVDhP3ZTLioNAEEWvEjRoEM2fxJ0IQvLbiuAL/yNm4UIURONj4cxU04NMxIyByWYOSEsVHG4XlsLHF3gDIj//nH8gvt1uCIIAwzDwyjrjOCIMQ+R5ziszC3GWZSjLEmmaou97Xl3Sti1830dRFLher7w6sxCfTieoqoqqqpAkCUv1SNM07FZd1+F4PMI0Td6ZWYj3+z0ulwuT13UN13V/yOk9iiI2KkVRYNs2drsd786sfseUisZBp67rsCyL1SkpjcEwDCaVJInVH3m6ICSI4xj3+x2aprGU9ND115J+8+vmTdMEz/NYckEQcDgccD6fn0qJTStNiWmuoijCcRzIssw762z+V1ByEm9ls/hVtkd4kTeJgU+YdJR2Af8zlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointment/xsj_x.png
// module id = tjLG
// module chunks = 1